/* eslint-disable @typescript-eslint/naming-convention */
import { DocumentTypeEntity } from '../../distribution/models';
import { FileNamingType } from './filenamingtype';

export interface IdentificationType {
  IdentificationTypeId: number;
  Name: string;
  Description: string;
  RegularExpression: string;
  DefaultQualifierEdifact: string;
  DefaultQualifierX12: string;
}

export interface IdentificationTypeQualifier {
  IdentificationTypeQualifiersId: number;
  IdentificationTypesId: number;
  Qualifier: string;
}

export class LightTrackingOptions {
  constructor(init?: Partial<LightTrackingOptions>) {
    Object.assign(this, init);
  }

  TrackMessageIn = true;
  TrackMessageContext = true;
  TrackCdm = true;
  TrackInterchangeOut = true;
  TrackAdditionalFilesForDocument = true;
  TrackAdditionalFilesForInterchangeOut = true;
}

export interface DocumentTypeDeveloper extends DocumentTypeEntity {
  LightTrackingOptions: LightTrackingOptions;
  FilenamingTypes: FileNamingType[];
}
